<p [innerHTML]="'application.records.preferences.info' | translate"></p>
@if (isLoadingData$ | async) {
  <div class="column-list" cdkDropList (cdkDropListDropped)="onDrop($event)">
    @for (item of columnPreferenceDataList; track item) {
      <div cdkDrag>
        <div class="column-item" cdkDragHandle>
          <ml-icon [iconName]="'chevron-bar-expand'"></ml-icon>
          <mat-checkbox [checked]="item.checked" (change)="onToggle(item)">
            <span>{{ item.label | translate }}</span>
          </mat-checkbox>
        </div>
        <div *cdkDragPreview class="drag-preview">
          <ml-icon [iconName]="'chevron-bar-expand'"></ml-icon>
          <mat-checkbox [checked]="item.checked" (change)="onToggle(item)">
            <span>{{ item.label | translate }}</span>
          </mat-checkbox>
        </div>
      </div>
    }
  </div>
} @else if (hasError()) {
  <div class="error-message">
    <ml-icon [iconName]="'cross-circle'" class="error-message-icon" />
    <p>{{ 'application.records.preferences.error-message' | translate }}</p>
  </div>
} @else {
  <ml-loader />
}
